const adminTableDom = "<'admin-table-controls'<'admin-table-control admin-table-control--length'l><'admin-table-control admin-table-control--processing'r><'admin-table-control admin-table-control--search'f>>t<'row'<'span6'i><'span6'p>>";

function checkedValues($inputs) {
  return $inputs.filter(':checked').map(function() {
    return this.value;
  }).get();
}

function setCheckedValues($inputs, values) {
  $inputs.each(function() {
    $(this).prop('checked', values.indexOf(this.value) !== -1);
  });
}

function selectedRadioValue($inputs) {
  return $inputs.filter(':checked').val();
}

function setRadioValue($inputs, value) {
  $inputs.filter(`[value="${value}"]`).prop('checked', true);
}

function enforceAtLeastOne($inputs, changedInput) {
  if ($inputs.filter(':checked').length > 0) {
    return true;
  }

  $(changedInput).prop('checked', true);
  return false;
}

function parseJsonFilter(rawFilter) {
  if (!rawFilter) {
    return {};
  }

  try {
    return JSON.parse(rawFilter) || {};
  } catch (error) {
    return {};
  }
}

function savedColumnSearch(dt, column) {
  const settings = dt.fnSettings();

  if (!settings.aoPreSearchCols || !settings.aoPreSearchCols[column]) {
    return '';
  }

  return settings.aoPreSearchCols[column].sSearch;
}

function decorateSearchField(wrapperSelector, options = {}) {
  const $filter = $(`${wrapperSelector} .dataTables_filter`);

  if ($filter.length === 0) {
    return;
  }

  const $input = $filter.find('input');
  if ($input.length === 0) {
    return;
  }

  $input.attr({
    'aria-label': options.ariaLabel || 'Suche',
    placeholder: options.placeholder || 'Suche ...'
  });

  if ($filter.hasClass('admin-search-decorated')) {
    return;
  }

  $input.detach();
  $filter.empty().append($input);
  $filter.addClass('admin-search-decorated');
}

function decorateLengthControl(wrapperSelector) {
  const $length = $(`${wrapperSelector} .dataTables_length`);

  if ($length.length === 0) {
    return;
  }

  const $select = $length.find('select');
  if ($select.length === 0) {
    return;
  }

  $select.attr('aria-label', 'Anzahl Einträge');

  $select.find('option').each(function() {
    const text = this.value === '-1' ? 'Alle Einträge' : `${this.value} Einträge`;
    $(this).text(text);
  });

  if ($length.hasClass('admin-length-decorated')) {
    return;
  }

  $select.detach();
  $length.empty().append($select);
  $length.addClass('admin-length-decorated');
}

function decorateTableControls(wrapperSelector, options = {}) {
  decorateLengthControl(wrapperSelector);
  decorateSearchField(wrapperSelector, options.search || {});
}

function filterJson(dt, filter, column) {
  return dt.fnFilter(JSON.stringify(filter), column, false, false, false, false);
}

window.NTRYAdminTableFilters = {
  checkedValues,
  decorateLengthControl,
  decorateSearchField,
  decorateTableControls,
  dom: adminTableDom,
  enforceAtLeastOne,
  filterJson,
  parseJsonFilter,
  savedColumnSearch,
  selectedRadioValue,
  setCheckedValues,
  setRadioValue
};

export default window.NTRYAdminTableFilters;
